export default __webpack_public_path__ + "static/media/JavaScript frameworks (5).67863fbc.gif";